// Recommendations
export const RECOMMENDATIONS_COUNT = 50;

// Search
export const DEFAULT_RADIUS = 20;
export const RADIUS_OPTIONS = [0, 10, 20, 50, 70, 100, 200];
export const MIN_SALARY = 0;
export const MAX_SALARY = 200_000;
export const SALARY_STEP = 1000;
export const SEARCH_STATE_PARAMS = {
  // Inputs
  keywords: 'keywords',
  location: 'location',
  radius: 'radius',
  // Filters
  benefit: 'benefit',
  careerLevel: 'careerLevel',
  city: 'city',
  company: 'company',
  country: 'country',
  discipline: 'discipline',
  employmentType: 'employmentType',
  industry: 'industry',
  remoteOption: 'remoteOption',
  salary: 'salary',
  // Other query params
  page: 'page',
  sort: 'sort',
} as const;
export const SMALL_SCREEN_BOTTOM_SHEET_PARAM = 'filter_view';
export const SEARCH_COUNT_LOCAL_STORAGE = 'SEARCH_QUERY_COUNT';

// Search alerts
export const MAX_ALERT_COUNT = 40;

// Recent searches
export const SEARCH_BOX_MAX_RECENT_SEARCHES = 5;
